'use client';

import { HouseholdSwitcherSidebar } from './HouseholdSwitcherSidebar';
import { useHouseholdSwitcher } from './use-household-switcher';

export function HouseholdSwitcherSidebarContainer() {
  const { ready, activeHouseholdId, memberHouseholds, onSelect, switching } = useHouseholdSwitcher();

  if (!ready) {
    return null;
  }

  return (
    <HouseholdSwitcherSidebar
      activeHouseholdId={activeHouseholdId}
      memberHouseholds={memberHouseholds}
      onSelect={onSelect}
      disabled={switching}
    />
  );
}
